export default "__VITE_ASSET__B$s$V4Ue__"